import { FormControl, Validators } from '@angular/forms';

export type ContentAssetDefinition = {
    name: string;
    description: string;
    playImporterId: number;
};

export class ContentLibraryDefinitionForm {
    name = new FormControl<string>('', { validators: [Validators.required], nonNullable: true });
    description = new FormControl<string | undefined>(undefined, { nonNullable: true });
    playImporterId = new FormControl<number | undefined>(undefined, { nonNullable: true });

    constructor(def?: ContentAssetDefinition) {
        if (def) {
            this.name.setValue(def.name || '');
            this.description.setValue(def.description || undefined);
            this.playImporterId.setValue(def.playImporterId || undefined);
        }
    }
}
